import React, { useEffect, useState } from "react";
import {
  getFormContent,
  getSingleSurvey,
  updateFormContent,
  surveyResultPreview,
  sharePreviewLink,
  addFormContent,
  imageUpload,
} from "../../../api/services/services";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Snackbar, Box, Typography, Grid, CircularProgress, IconButton, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import moment from "moment";
import { ToWords } from "to-words";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
import html2pdf from "html2pdf.js";
import { Bucket } from "../../../api/config/apiConfig";
import ContactDetailField from "../../molecules/ContactDetailField";
import TextArea from "../../atoms/Textarea";
import Input from "../../atoms/Input";
import LoadingModal from "../../molecules/LoadingModal";
import MySignatureCanvas from "../../molecules/signature_canvas";
import ShareWithClientsModal from "../../molecules/ShareWithClients";
import PrintComponent from "../PrintComponent";
import InvoiceDownload from "./ClientSide/download.jsx";
import trashIcn from "../../../imgs/trash.png";
import PremiumPageLayout from "../../templates/PremiumPageLayout";
import PremiumCard from "../../molecules/PremiumCard";
import SectionHeader from "../../molecules/SectionHeader";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PersonIcon from "@mui/icons-material/Person";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PolicyIcon from "@mui/icons-material/Policy";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import ShareIcon from "@mui/icons-material/Share";
import PrintIcon from "@mui/icons-material/Print";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { sendSuperAdminVerificationForEdit } from "../PrebidAgreement/creation/service";
import SuperAdminVerifationModal from "../../molecules/SuperAdminVerifationModal";

const Invoice = () => {
  const { surveyId, id, flg } = useParams();
  const [surveyData, setSurveyData] = useState(null);
  const navigate = useNavigate();

  const [formContentId, setFormContentId] = useState("");
  const [isEdit, setIsEdit] = useState(flg == "1" ? true : false);

  const [isLoading, setIsLoading] = useState(false);
  const [formContent, setFormContent] = useState({
    clientName: "",
    clientEmail: "",
    clientSign: "",
    adminSign: "",
    invoiceNo: "",
    vendorNo: "",
    to: "",
    for: "",
    date: "",
    dataRows: [],
    bankDetails: {
      iban: "",
      title: "",
      swiftCode: "",
      branchNameCode: "",
    },
    termsAndConditions: "",
    validity: "",
    totalAmountinEnglish: "",
    totalAmount: "",
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  var totalAmount = 0;

  const words = new ToWords();

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const [isShare, setIsShare] = useState(false);

  //
  const getSurveyPreview = () => {
    surveyResultPreview(surveyId)
      .then((response) => {
        setSurveyData(response?.data?.data?.surveyDetail);
        let values = { ...formContent };
        values.clientEmail = `${response?.data?.data?.surveyDetail?.email}`;
        values.clientName = `${response?.data?.data?.surveyDetail?.name}`;
        values.invoiceNo = `${response?.data?.data?.surveyDetail?.id}`;
        values.to = `${response?.data?.data?.surveyDetail?.name}`;

        let dR = [];

        // response?.data?.data?.surveyDetail?.surveyResult?.surveyItems?.map(
        //   (itm, ind) => {
        //     dR[ind] = {
        //       no: ind + 1,
        //       description: itm?.name,
        //       quantity: itm?.quantity,
        //       amount: "",
        //     };
        //   }
        // );

        let itemsInd = 0;

        // console.log(response?.data?.data?.surveyDetail?.surveyResult?.surveyRooms)
        response?.data?.data?.surveyDetail?.surveyResult?.surveyRooms?.forEach(
          (rm, ind) => {
            // console.log(rm?.roomItems);
            rm?.roomItems?.forEach((rmItm, ind) => {
              // console.log(itemsInd);
              // console.log(values.dataRows);

              // Adding a new object to the dataRows array
              values.dataRows.push({
                no: ind + 1,
                description: rmItm?.name,
                quantity: rmItm?.quantity,
                amount: "",
              });
              itemsInd += 1;
            });
          }
        );

        // values.dataRows = dR;

        getFormContent("be5690e1-df05-4791-a214-2235c757f0f3", surveyId)
          .then((res) => {
            values.bankDetails = {
              iban: res?.data?.data?.content?.bankDetails?.iban
                ? res?.data?.data?.content?.bankDetails?.iban
                : "",
              title: res?.data?.data?.content?.bankDetails?.title
                ? res?.data?.data?.content?.bankDetails?.title
                : "",
              swiftCode: res?.data?.data?.content?.bankDetails?.swiftCode
                ? res?.data?.data?.content?.bankDetails?.swiftCode
                : "",
              branchNameCode: res?.data?.data?.content?.bankDetails
                ?.branchNameCode
                ? res?.data?.data?.content?.bankDetails?.branchNameCode
                : "",
            };
            setFormContent(values);
            setIsLoading(false);
          })
          .catch((error) => {
            // setSnackbarMessage(error?.response?.data?.message);
            // setOpenSnackbar(true);

            if (error?.response?.data?.statusCode == 401) {
              localStorage.clear();
              window.location.pathname = "/login";
            }

            setIsLoading(false);
            setFormContent(values);
          });
      })
      .catch((error) => {
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }
      });
  };

  //
  const getSurvey = () => {
    getSingleSurvey(surveyId)
      .then((response) => {
        if (response?.data?.data?.status == "submitted") getSurveyPreview();
        else {
          setSurveyData(response?.data?.data);
          let values = { ...formContent };

          values.clientEmail = `${response?.data?.data?.email}`;
          values.clientName = `${response?.data?.data?.name}`;
          values.invoiceNo = `${response?.data?.data?.id}`;
          values.to = `${response?.data?.data?.name}`;

          getFormContent("be5690e1-df05-4791-a214-2235c757f0f3", surveyId)
            .then((res) => {
              values.bankDetails = {
                iban: res?.data?.data?.content?.bankDetails?.iban
                  ? res?.data?.data?.content?.bankDetails?.iban
                  : "",
                title: res?.data?.data?.content?.bankDetails?.title
                  ? res?.data?.data?.content?.bankDetails?.title
                  : "",
                swiftCode: res?.data?.data?.content?.bankDetails?.swiftCode
                  ? res?.data?.data?.content?.bankDetails?.swiftCode
                  : "",
                branchNameCode: res?.data?.data?.content?.bankDetails
                  ?.branchNameCode
                  ? res?.data?.data?.content?.bankDetails?.branchNameCode
                  : "",
              };

              console.log(values);

              setFormContent(values);
              setIsLoading(false);
            })
            .catch((error) => {
              // setSnackbarMessage(error?.response?.data?.message);
              // setOpenSnackbar(true);

              if (error?.response?.data?.statusCode == 401) {
                localStorage.clear();
                window.location.pathname = "/login";
              }

              setIsLoading(false);
              setFormContent(values);
            });
        }
      })
      .catch((error) => {
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }
      });
  };

  const [mediaKeysToSend, setMediaKeysToSend] = useState([]);
  const [mediaKeysToRemove, setMediaKeysToRemove] = useState([]);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  //
  const addContent = () => {
    setIsLoading(true);
    const body = {
      formId: id,
      surveyId: surveyId,
      content: formContent,
      mediaKeys: mediaKeysToSend,
    };
    addFormContent(body)
      .then(() => {
        setSnackbarMessage("Invoice has been added successfully!");
        setOpenSnackbar(true);

        setTimeout(() => {
          navigate(-1);
          setIsLoading(false);
        }, 1000);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  //
  const updateContent = () => {
    setIsLoading(true);
    const body = {
      formId: id,
      surveyId: surveyId,
      content: formContent,
      mediaKeys: mediaKeysToSend,
      removedMediaKeys: mediaKeysToRemove,
    };
    updateFormContent(body, formContentId)
      .then((res) => {
        setSnackbarMessage("Invoice has been updated successfully!");
        setOpenSnackbar(true);
        getContent();
        setIsEdit(false);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  //
  const getContent = () => {
    setIsLoading(true);
    getFormContent(id, surveyId)
      .then((res) => {
        setFormContentId(res.data.data.uuid);
        setFormContent(res.data.data.content);
        setIsLoading(false);
        setMediaKeysToSend([]);
        setMediaKeysToRemove([]);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
        setMediaKeysToSend([]);
        setMediaKeysToRemove([]);
      });
  };

  useEffect(() => {
    if (flg == "1") getSurvey();
    else getContent();
  }, []);

  const [show, setShow] = useState(false);
  const options = {
    // resolution: Resolution.HIGH,
    page: {
      // margin is in MM, default is Margin.NONE = 0
      margin: Margin.SMALL,
      // default is 'A4'
      format: "letter",
      // default is 'portrait'
      orientation: "portrait",
    },
    canvas: {
      // default is 'image/jpeg' for better size performance
      mimeType: "image/png",
      qualityRatio: 1,
    },
    overrides: {
      pdf: {
        compress: true,
      },
    },
  };

  //
  const generatePdf = () => {
    if (window.innerWidth <= 768) {
      if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") {
        setSnackbarMessage("For a good experience, please use a desktop screen");
        setOpenSnackbar(true);
      } else {
        alert("For a good experience, please use a desktop screen");
      }
      return;
    }

    setShow(true);

    setTimeout(() => {
      const content = document.getElementById("content-to-convert"); // Replace with the ID of the element you want to convert to PDF

      const currentDateTime = new Date();
      const filename = `survey_${currentDateTime.toISOString()}.pdf`;

      const pdfOptions = {
        margin: 5,
        filename: filename,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        }, // Set the page size here
      };

      let temp = html2pdf().from(content).set(pdfOptions).outputPdf();
      temp.save(filename);

      setShow(false);
    }, 3500);
  };

  const [downloadText, setDownloadText] = useState("download");

  const getTargetElement = () => document.getElementById("content-id");

  //
  const shareWithClient = (data) => {
    let ems = [];
    let emsInd = 0;
    data.map((dt) => {
      if (dt.trim().length != 0) {
        ems[emsInd] = dt;
        emsInd++;
      }
    });

    setIsLoading(true);
    const body = {
      surveyId: surveyId,
      formId: id,
      emails: ems,
      formRoute: "invoice-preview",
    };
    sharePreviewLink(body)
      .then(() => {
        setSnackbarMessage(
          "Invoice has been shared with the respective emails successfully!"
        );
        setOpenSnackbar(true);

        setIsLoading(false);
        setIsShare(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  const handleAddNewDataRows = () => {
    const values = { ...formContent };
    const valuesRows = [...formContent?.dataRows];
    valuesRows.push({
      no: "",
      description: "",
      quantity: "",
      amount: "",
    });
    values.dataRows = valuesRows;

    setFormContent(values);
  };

  const handleRemoveDataRows = (ind) => {
    const values = { ...formContent };
    const valuesRows = [...formContent?.dataRows];
    valuesRows.splice(ind, 1);
    values.dataRows = valuesRows;

    setFormContent(values);
  };


  const [uploadText, setUploadText] = useState("Upload Sign");

  //
  const [isSignCanvas, setSignCanvas] = useState(false);
  const uploadFile = async (file) => {
    setIsLoading(true);

    handleOpen();
    setUploadText("Uploading...");
    const fd = new FormData();
    fd.append("image", file);

    imageUpload(fd)
      .then((res) => {
        let values = { ...formContent };

        if (formContent.adminSign?.trim()?.length != 0) {
          let dlt = [...mediaKeysToRemove];
          dlt.push(formContent.adminSign);
          setMediaKeysToRemove(dlt);
        }

        values.adminSign = res?.data?.data?.key;
        setFormContent(values);

        let md = [...mediaKeysToSend];
        md.push(res?.data?.data?.key);
        setMediaKeysToSend(md);

        setIsLoading(false);
        setUploadText("Upload Sign");
        handleClose();
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setUploadText("Upload Sign");

        setIsLoading(false);
        handleClose();
      });
  };

  const [isVerified, setIsVerified] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);

  const sendEditRequestToAdmin = () => {
    setIsEditLoading(true);
    sendSuperAdminVerificationForEdit()
      .then((response) => {
        setIsVerified(true);
        setIsEditLoading(false);
      })
      .catch((error) => {
        setIsVerified(false);
        setIsEditLoading(false);
      });
  };

  const pageActions = (
    <>
      {!isEdit && (
        <Button
          variant="outlined"
          startIcon={<EditIcon />}
          onClick={() => sendEditRequestToAdmin()}
          disabled={isEditLoading}
          sx={{ borderRadius: "10px", textTransform: "none", fontWeight: 600 }}
        >
          Edit
        </Button>
      )}

      {!isEdit && (
        <Button
          variant="outlined"
          startIcon={<ShareIcon />}
          onClick={() => setIsShare(true)}
          disabled={isLoading}
          sx={{ borderRadius: "10px", textTransform: "none", fontWeight: 600 }}
        >
          Share
        </Button>
      )}

      {isEdit && flg == "2" && (
        <Button
          variant="outlined"
          startIcon={<CancelIcon />}
          color="error"
          onClick={() => {
            getContent();
            setIsEdit(false);
          }}
          disabled={isLoading}
          sx={{ borderRadius: "10px", textTransform: "none", fontWeight: 600 }}
        >
          Cancel
        </Button>
      )}

      {isEdit && (
        <Button
          variant="contained"
          startIcon={<SaveIcon />}
          onClick={() => {
            if (flg == "1") addContent();
            else updateContent();
          }}
          disabled={isLoading}
          sx={{ borderRadius: "10px", textTransform: "none", fontWeight: 600, background: "linear-gradient(45deg, #1976d2, #1565c0)" }}
        >
          Save
        </Button>
      )}

      {!isEdit && (
        <Button
          variant="contained"
          startIcon={<PrintIcon />}
          onClick={() => {
            const tempTitle = document.title;
            const newTitle = `Invoice-${formContent?.clientName || 'Document'}-${moment().format("DD.MM.YYYY")}`;
            document.title = newTitle;
            
            // Standardized delay for print and title restoration
            setTimeout(() => {
              window.print();
              setTimeout(() => {
                document.title = tempTitle;
              }, 2000);
            }, 500);
          }}
          disabled={isLoading}
          sx={{ borderRadius: "10px", textTransform: "none", fontWeight: 600, background: "linear-gradient(45deg, #1976d2, #1565c0)" }}
        >
          Save as PDF
        </Button>
      )}
    </>
  );

  return (
    <>
      <PremiumPageLayout
        title="Invoice"
        actions={pageActions}
        onBack={() => navigate(-1)}
      >
        <SectionHeader title="General Information" icon={<PersonIcon />} />
        <PremiumCard sx={{ marginBottom: "32px", padding: "24px" }}>
          {/* customer detail*/}
          <div className="d-flex mt-2">
            {/* left col */}
            <div className={`left-col w-100 text-start`}>
              <Typography variant="body1" gutterBottom>
                <ContactDetailField
                  label="Invoice No."
                  isEdit={isEdit}
                  type="text"
                  minWidth={"160px"}
                  value={formContent?.invoiceNo}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.invoiceNo = e.target.value;
                    setFormContent(values);
                  }}
                  disabled
                />

                <ContactDetailField
                  label="Shelozon Vendor #"
                  isEdit={isEdit}
                  type="text"
                  minWidth={"160px"}
                  value={formContent?.vendorNo}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.vendorNo = e.target.value;
                    setFormContent(values);
                  }}
                />
                <div
                  className={`${
                    isEdit ? "mb-4" : "mb-2"
                  } d-flex align-items-start contactDetail-label  `}
                >
                  <label
                    htmlFor={"To"}
                    className={` me-3 ${isEdit ? "w-25" : ""} ${"fw-bold"}`}
                    style={{ minWidth: "160px" }}
                  >
                    <b> To:</b>
                  </label>
                  {isEdit ? (
                    <TextArea
                      label="To"
                      isEdit={isEdit}
                      type="text"
                      minWidth={"160px"}
                      value={formContent?.to}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values.to = e.target.value;
                        setFormContent(values);
                      }}
                      row={4}
                      disabled
                    />
                  ) : (
                    <span>{formContent?.to ? formContent?.to : "-"}</span>
                  )}
                </div>
                <div
                  className={`${
                    isEdit ? "mb-4" : "mb-2"
                  } d-flex align-items-start contactDetail-label  `}
                >
                  <label
                    htmlFor={"To"}
                    className={` me-3 ${isEdit ? "w-25" : ""} ${"fw-bold"}`}
                    style={{ minWidth: "160px" }}
                  >
                    <b> For:</b>
                  </label>
                  {isEdit ? (
                    <TextArea
                      label="For"
                      isEdit={isEdit}
                      type="text"
                      minWidth={"160px"}
                      value={formContent?.for}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values.for = e.target.value;
                        setFormContent(values);
                      }}
                      row={4}
                    />
                  ) : (
                    <span>{formContent?.for ? formContent?.for : "-"}</span>
                  )}
                </div>
              </Typography>
            </div>

            <div
              className={`right-col w-100 d-flex justify-content-end align-items-baseline`}
            >
              <Typography variant="body1" gutterBottom>
                <ContactDetailField
                  label="Date"
                  isEdit={isEdit}
                  type="date"
                  value={formContent?.date}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.date = e.target.value;
                    setFormContent(values);
                  }}
                />
              </Typography>
            </div>
          </div>
          {/* /customer detail */}
        </PremiumCard>
          {/* /customer detail */}

        <SectionHeader 
          title="Invoice Items" 
          icon={<ReceiptIcon />} 
          action={isEdit && (
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => handleAddNewDataRows()}
              sx={{ borderRadius: "8px", textTransform: "none" }}
            >
              Add New Item
            </Button>
          )}
        />
        <PremiumCard sx={{ marginBottom: "32px", padding: "0px", overflow: "hidden" }}>
          <TableContainer>
            <Table>
              {/* Table Header */}
              <TableHead sx={{ backgroundColor: "#f8fafc" }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, color: "#475569" }}>Item No</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#475569" }}>Description</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#475569" }}>Quantity</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#475569" }}>Amount</TableCell>
                  {isEdit && <TableCell sx={{ fontWeight: 600, color: "#475569" }}></TableCell>}
                </TableRow>
              </TableHead>
              <TableBody>
                {formContent?.dataRows?.length > 0 ? (
                  <>
                    {formContent?.dataRows?.map((row, index) => (
                      <TableRow key={index} sx={{ "&:hover": { backgroundColor: "#f1f5f9" } }}>
                        <TableCell sx={{ color: "#64748b" }}>{index + 1}</TableCell>
                        <TableCell>
                          {isEdit ? (
                            <TextArea
                              id="description"
                              label="Description"
                              type="text"
                              value={row?.description}
                              onChange={(e) => {
                                const values = { ...formContent };
                                const valuesRows = [...formContent?.dataRows];
                                valuesRows[index].description = e.target.value;
                                values.dataRows = valuesRows;
                                setFormContent(values);
                              }}
                              inline={{ width: "100%" }}
                              rows={2}
                            />
                          ) : (
                            <Typography sx={{ color: "#334155" }}>{row.description || "-"}</Typography>
                          )}
                        </TableCell>
                        <TableCell>
                          {isEdit ? (
                            <Input
                              id="quantity"
                              label="Qty"
                              type="text"
                              style="full-border-field"
                              value={row?.quantity}
                              onChange={(e) => {
                                const values = { ...formContent };
                                const valuesRows = [...formContent?.dataRows];
                                valuesRows[index].quantity = e.target.value;
                                values.dataRows = valuesRows;
                                setFormContent(values);
                              }}
                            />
                          ) : (
                            <Typography sx={{ color: "#334155" }}>{row?.quantity || "-"}</Typography>
                          )}
                        </TableCell>
                        <TableCell>
                          {isEdit ? (
                            <Input
                              id="amount"
                              label="Amount"
                              type="text"
                              style="full-border-field"
                              value={row?.amount}
                              onChange={(e) => {
                                const values = { ...formContent };
                                const valuesRows = [...formContent?.dataRows];
                                valuesRows[index].amount = e.target.value;
                                values.dataRows = valuesRows;
                                setFormContent(values);
                              }}
                            />
                          ) : (
                            <Typography sx={{ color: "#334155", fontWeight: 500 }}>{row?.amount || "-"}</Typography>
                          )}
                        </TableCell>
                        {isEdit && (
                          <TableCell>
                            <Button 
                              color="error" 
                              onClick={() => handleRemoveDataRows(index)}
                              sx={{ minWidth: "auto", padding: "8px" }}
                            >
                              <img src={trashIcn} height={18} width={18} />
                            </Button>
                          </TableCell>
                        )}
                      </TableRow>
                    ))}

                    <TableRow sx={{ backgroundColor: "#f8fafc" }}>
                      <TableCell colSpan={isEdit ? 5 : 4} sx={{ padding: "16px 24px" }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <Typography sx={{ fontWeight: 700, color: "#1e293b" }}>Grand Total</Typography>
                          <Box sx={{ display: "flex", gap: 4, alignItems: "center" }}>
                            {isEdit ? (
                              <Input
                                label="Total Amount in words"
                                type="text"
                                style="full-border-field"
                                value={formContent?.totalAmountinEnglish}
                                onChange={(e) => {
                                  const values = { ...formContent };
                                  values.totalAmountinEnglish = e.target.value;
                                  setFormContent(values);
                                }}
                                inline={{ width: "300px" }}
                              />
                            ) : (
                              <Typography sx={{ color: "#64748b", fontStyle: "italic" }}>
                                {formContent?.totalAmountinEnglish || "-"}
                              </Typography>
                            )}
                            
                            {isEdit ? (
                              <Input
                                label="Total Amount"
                                type="text"
                                style="full-border-field"
                                value={formContent?.totalAmount}
                                onChange={(e) => {
                                  const values = { ...formContent };
                                  values.totalAmount = e.target.value;
                                  setFormContent(values);
                                }}
                                inline={{ width: "150px" }}
                              />
                            ) : (
                              <Typography sx={{ fontWeight: 700, color: "#0f172a", fontSize: "1.1rem" }}>
                                {formContent?.totalAmount || "-"}
                              </Typography>
                            )}
                          </Box>
                        </Box>
                      </TableCell>
                    </TableRow>
                  </>
                ) : (
                  <TableRow>
                    <TableCell colSpan={isEdit ? 5 : 4} align="center" sx={{ py: 4 }}>
                      {isLoading ? <CircularProgress size={24} /> : "No Records to Show"}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </PremiumCard>

        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <SectionHeader title="Bank Details" icon={<AccountBalanceIcon />} />
            <PremiumCard sx={{ padding: "24px" }}>
              <ContactDetailField
                label="Account Title"
                isEdit={isEdit}
                type="text"
                value={formContent?.bankDetails?.title}
                onChange={(e) => {
                  let values = { ...formContent };
                  values.bankDetails.title = e.target.value;
                  setFormContent(values);
                }}
              />
              <ContactDetailField
                label="IBAN No"
                isEdit={isEdit}
                type="text"
                value={formContent?.bankDetails?.iban}
                onChange={(e) => {
                  let values = { ...formContent };
                  values.bankDetails.iban = e.target.value;
                  setFormContent(values);
                }}
              />
              <ContactDetailField
                label="Swift Code"
                isEdit={isEdit}
                type="text"
                value={formContent?.bankDetails?.swiftCode}
                onChange={(e) => {
                  let values = { ...formContent };
                  values.bankDetails.swiftCode = e.target.value;
                  setFormContent(values);
                }}
              />
              <ContactDetailField
                label="Branch"
                isEdit={isEdit}
                type="text"
                value={formContent?.bankDetails?.branchNameCode}
                onChange={(e) => {
                  let values = { ...formContent };
                  values.bankDetails.branchNameCode = e.target.value;
                  setFormContent(values);
                }}
              />
            </PremiumCard>
          </Grid>

          <Grid item xs={12} md={6}>
            <SectionHeader title="Terms & Validity" icon={<PolicyIcon />} />
            <PremiumCard sx={{ padding: "24px" }}>
              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "#64748b", mb: 1 }}>
                  Terms & Conditions
                </Typography>
                {isEdit ? (
                  <TextArea
                    rows="3"
                    label="Terms & Conditions..."
                    value={formContent?.termsAndConditions}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.termsAndConditions = e.target.value;
                      setFormContent(values);
                    }}
                  />
                ) : (
                  <Typography sx={{ color: "#334155" }}>{formContent?.termsAndConditions || "-"}</Typography>
                )}
              </Box>

              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "#64748b", mb: 1 }}>
                  Validity
                </Typography>
                {isEdit ? (
                  <TextArea
                    rows="2"
                    label="Validity..."
                    value={formContent?.validity}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.validity = e.target.value;
                      setFormContent(values);
                    }}
                  />
                ) : (
                  <Typography sx={{ color: "#334155" }}>{formContent?.validity || "-"}</Typography>
                )}
              </Box>
            </PremiumCard>
          </Grid>
        </Grid>

        <Box sx={{ mt: 4, display: "flex", justifyContent: "flex-end" }}>
          <Box sx={{ textAlign: "center", width: "300px" }}>
            <Box sx={{ height: "100px", display: "flex", alignItems: "center", justifyContent: "center", borderBottom: "2px solid #e2e8f0", mb: 1 }}>
              {formContent?.adminSign?.trim()?.length > 0 ? (
                <Box sx={{ position: "relative" }}>
                  <img src={`${Bucket}${formContent.adminSign}`} height={80} style={{ objectFit: "contain" }} />
                  {isEdit && (
                    <Box sx={{ position: "absolute", top: -10, right: -40, display: "flex", gap: 1 }}>
                      <IconButton size="small" onClick={() => setSignCanvas(true)} sx={{ backgroundColor: "#fff", boxShadow: 1 }}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <IconButton 
                        size="small" 
                        color="error" 
                        sx={{ backgroundColor: "#fff", boxShadow: 1 }}
                        onClick={() => {
                          let values = { ...formContent };
                          values.adminSign = "";
                          setFormContent(values);
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              ) : (
                isEdit && (
                  <Button
                    variant="outlined"
                    startIcon={<BorderColorIcon />}
                    onClick={() => setSignCanvas(true)}
                    sx={{ borderRadius: "8px" }}
                  >
                    {uploadText}
                  </Button>
                )
              )}
            </Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#1e293b" }}>
              Shelozon Movers Packers & Logistics
            </Typography>
            <Typography variant="caption" sx={{ color: "#64748b" }}>
              Authorized Signature
            </Typography>
          </Box>
        </Box>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            severity={snackbarMessage?.includes("successful") ? "success" : "error"}
            onClose={handleCloseSnackbar}
          >
            {snackbarMessage}
          </MuiAlert>
        </Snackbar>

        {isShare && (
          <ShareWithClientsModal
            open={isShare}
            onClose={() => setIsShare(false)}
            onSuccess={(emails) => shareWithClient(emails)}
          />
        )}

        <LoadingModal open={open} handleClose={handleClose} />
        
        {isSignCanvas && (
          <MySignatureCanvas
            open={isSignCanvas}
            onClose={() => setSignCanvas(false)}
            onSuccess={(file) => !isLoading && uploadFile(file)}
          />
        )}

        {isVerified && (
          <SuperAdminVerifationModal
            open={isVerified}
            onClose={() => setIsVerified(false)}
            onSuccess={() => {
              setIsEdit(true);
              setIsVerified(false);
            }}
            onError={() => {
              setSnackbarMessage("Invalid Confirm Pin");
              setOpenSnackbar(true);
            }}
          />
        )}
      </PremiumPageLayout>

      <PrintComponent>
        <InvoiceDownload surveyData={surveyData} formContent={formContent} />
      </PrintComponent>
    </>
  );
};
export default Invoice;
